import React, { createContext, useContext, useState } from "react";

const ReportContext = createContext();

export function useReport(reportKey) {
  const context = useContext(ReportContext);
  if (!context) throw new Error("useReport must be used within a ReportProvider");
  const { state, setState } = context;

  // Get state for this reportKey
  const reportState = state[reportKey] || {};
  // Helper to update only this reportKey
  function updateReportState(updates) {
    setState(prev => ({
      ...prev,
      [reportKey]: { ...prev[reportKey], ...updates }
    }));
  }

  return [reportState, updateReportState];
}

export function ReportProvider({ children }) {
  const [state, setState] = useState({});
  return (
    <ReportContext.Provider value={{ state, setState }}>
      {children}
    </ReportContext.Provider>
  );
}